import YouTubeProperty from "./YouTubeProperty";
import SpotifyProperty from "./SpotifyProperty";
import LinkProperty from "./LinkProperty";
import TwitterProperty from "./Twitter";
const MetaProperties = ({ meta, isMobile = false }) => {
  // if (meta[0].site_name == "YouTube")
  return (
    <>
      {meta?.map((meta, mIndex) => {
        switch (meta.site_name) {
          case "YouTube":
            return <YouTubeProperty meta={meta} isMobile={isMobile} />;
          case "Twitter":
            return <TwitterProperty meta={meta} />;
          case "Spotify":
            return <SpotifyProperty meta={meta} />;
          default:
            return <LinkProperty key={mIndex} meta={meta} />;
        }
      })}
    </>
  );
};

export default MetaProperties;
